import React from 'react'
import './style.css'

export default function CompHeader(props) {
    return (
        <div className={props.cHeader} onClick={props.onClick}> 
            <img className={props.cIcon} src={props.src} alt={props.alt} />
            <div className={props.cUsers}>
                <span>{props.span}</span> 
                <p className={props.cText}>{props.text}</p>
            </div>
        </div>
    )
}
